import { IState, ITranscoHyperProxi } from './types'
import moment from 'moment'

const getAll = (state: IState) => {
  return state.transcoHyperProxi
}

const getAllTranscoHyperProxisProducts = (state: IState) => {
  return state.transcoHyperProxiProduct
}

const isCreated = (state: IState) => {
  return state.isCreated
}

const isModified = (state: IState) => {
  return state.isModified
}

const isDeleted = (state: IState) => {
  return state.isDeleted
}

const areTranscosLoaded = (state: IState) => {
  return state.areTranscosLoaded
}

const areTranscosProductsLoaded = (state: IState) => {
  return state.areTranscosProductsLoaded
}

const isLoading = (state: IState) => {
  return state.isLoading
}

const providerSearch = (state: IState) => {
  return state.providerSearch
}

const productSearch = (state: IState) => {
  return state.productSearch
}

export default {
  getAll,
  getAllTranscoHyperProxisProducts,
  isCreated,
  isModified,
  isDeleted,
  areTranscosLoaded,
  areTranscosProductsLoaded,
  isLoading,
  providerSearch,
  productSearch,
}
